import React from 'react';
import { ArrowUpRight } from 'lucide-react';
const projects = [{
  id: 1,
  title: 'Neon Horizon',
  category: 'Brand Identity',
  image: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=800&q=80',
  height: 'h-[400px]'
}, {
  id: 2,
  title: 'Urban Decay',
  category: 'Photography',
  image: 'https://images.unsplash.com/photo-1493397212122-2b85dda8106b?auto=format&fit=crop&w=800&q=80',
  height: 'h-[600px]'
}, {
  id: 3,
  title: 'Future Tech',
  category: 'Web Design',
  image: 'https://images.unsplash.com/photo-1519638399535-1b036603ac77?auto=format&fit=crop&w=800&q=80',
  height: 'h-[500px]'
}, {
  id: 4,
  title: 'Abstract Flow',
  category: 'Art Direction',
  image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80',
  height: 'h-[450px]'
}, {
  id: 5,
  title: 'Minimalist',
  category: 'Product Design',
  image: 'https://images.unsplash.com/photo-1449247709967-d4461a6a6103?auto=format&fit=crop&w=800&q=80',
  height: 'h-[550px]'
}, {
  id: 6,
  title: 'Dark Matter',
  category: '3D Motion',
  image: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80',
  height: 'h-[400px]'
}];
export function ProjectGrid() {
  return <section id="work" className="py-24 px-6 bg-black" data-id="element-90">
      <div className="max-w-7xl mx-auto" data-id="element-91">
        <div className="flex justify-between items-end mb-16" data-id="element-92">
          <div data-id="element-93">
            <h2 className="text-yellow-400 font-bold tracking-widest uppercase mb-2" data-id="element-94">
              Selected Work
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-white" data-id="element-95">
              Featured Projects
            </h3>
          </div>
          <a href="#" className="hidden md:flex items-center text-white hover:text-yellow-400 transition-colors uppercase font-bold tracking-wider text-sm" data-id="element-96">
            View All Work <ArrowUpRight className="ml-2 w-4 h-4" data-id="element-97" />
          </a>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8" data-id="element-98">
          {projects.map(project => <div key={project.id} className="group relative break-inside-avoid overflow-hidden cursor-pointer" data-id="element-99">
              <div className={`w-full ${project.height} relative`} data-id="element-100">
                <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-101" />

                {/* Overlay */}
                <div className="absolute inset-0 bg-yellow-400/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center items-center p-8 text-center" data-id="element-102">
                  <span className="text-black font-bold tracking-widest uppercase text-sm mb-4 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75" data-id="element-103">
                    {project.category}
                  </span>
                  <h3 className="text-black text-3xl font-black uppercase tracking-tighter translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100" data-id="element-104">
                    {project.title}
                  </h3>
                  <div className="mt-6 w-12 h-1 bg-black transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-150" data-id="element-105" />
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-106">
          <a href="#" className="inline-flex items-center text-white hover:text-yellow-400 transition-colors uppercase font-bold tracking-wider text-sm" data-id="element-107">
            View All Work <ArrowUpRight className="ml-2 w-4 h-4" data-id="element-108" />
          </a>
        </div>
      </div>
    </section>;
}